import http from './http';
import { expandRoles } from './roleHierarchy';

const TOKEN_KEY = 'tr_token';
const USER_KEY = 'tr_user';

export async function login(username, password) {
  const { data } = await http.post('/auth/login', { username, password });
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(USER_KEY, JSON.stringify(data.user));
  return data.user;
}

export async function register(payload) {
  const { data } = await http.post('/auth/register', payload);
  return data;
}

export async function forgotPassword(username) {
  const { data } = await http.post('/auth/forgot-password', { username });
  return data;
}

export async function resetPassword(token, password) {
  const { data } = await http.post('/auth/reset-password', { token, password });
  return data;
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getCurrentUser() {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function updateCurrentUser(patch) {
  const user = { ...getCurrentUser(), ...patch };
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  return user;
}

export function isAuthenticated() {
  return !!getToken();
}

export function hasRole(...roles) {
  const user = getCurrentUser();
  if (!user) return false;
  const effective = expandRoles(user.roles);
  return effective.includes('superadmin') || effective.some((r) => roles.includes(r));
}
